import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function findTitlePath(fields: SchemaField[]): string[] | null {
  const stringTypes = ['string', 'varchar', 'text']
  const preferredNames = ['title', 'name', 'label']

  for (const preferredName of preferredNames) {
    const field = fields.find((f) => f.name === preferredName && stringTypes.includes(f.type))
    if (field) return [field.name]
  }

  const directStringField = fields.find((f) => stringTypes.includes(f.type))
  if (directStringField) return [directStringField.name]

  for (const field of fields) {
    if ((field.type === 'group' || field.type === 'section') && field.fields?.length) {
      const nestedPath = findTitlePath(field.fields)
      if (nestedPath) return [field.name, ...nestedPath]
    }
  }

  return null
}
